<template>
  <div class="page-vue-embed">
    <div class="wgk-wrapper">
      <v-app>
        <v-main>
          <div class="wgk-dehn-bgcolor__light">
            <v-container class="wgk-container__outer">
              <configurator-title></configurator-title>
              <v-alert
                v-if="this.$store.getters.errors[0]"
                border="right"
                colored-border
                type="error"
                elevation="2"
              >
                Entschuldigung: Es ist ein Fehler aufgetreten. Laden Sie die Seite neu oder versuchen Sie es später noch einmal.
              </v-alert>


              <div class="d-flex flex-column justify-center align-center"
                   v-if="this.$store.state.loadingStatus"
              >
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div class="mt-4">loading</div>
              </div>

              <stepper-default
                v-if="!this.$store.state.loadingStatus && !this.$store.state.desktopOptimizedSwitch"
              ></stepper-default>

              <stepper-desktop-variant
                v-if="!this.$store.state.loadingStatus && this.$store.state.desktopOptimizedSwitch"
              ></stepper-desktop-variant>

            </v-container>
          </div>
        </v-main>
      </v-app>
      <!--
      <div style="position: absolute;top: 10px; right: 20px; width: 48%;height:150px;background: white;overflow: auto;">
          <pre style="font-size: 60%;">
            {{ this.$store.state.wgkStepsValues }}
          </pre>
      </div>
      <div style="position: absolute;top: 10px; left: 20px; width: 48%;height:150px;background: white;overflow: auto;">
          <pre style="font-size: 60%;">
            {{ this.$store.state.wgkStepsValuesOld }}
          </pre>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import ConfiguratorTitle from './components/ConfiguratorTitle.vue'
import StepperDefault from "./components/StepperDefault";
import StepperDesktopVariant from "./components/StepperDesktopVariant";
import {mapState} from "vuex";

export default {
  name: 'App',

  components: {
    ConfiguratorTitle,
    StepperDefault,
    StepperDesktopVariant
  },

  data: () => ({
    instanceId: ''
  }),

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    },
    ...mapState({
      desktopOptimizedSwitch: state => state.desktopOptimizedSwitch
    })
  },

  created() {

    this.$store.dispatch('updateDesktopOptimizedSwitch', this.isMobile);

    // save back initial query params
    this.$store.commit('SET_INITIAL_QUERY_PARAMS',this.$store.state.route.query);

    this.$store.dispatch('setInitialData');

    const appRoot = document.getElementById('decoupled-page-root');
    if (Object.prototype.hasOwnProperty.call(appRoot.dataset, 'hookurl')) {
      this.$store.commit('SET_ELBRIDGE_HOOK_URL', appRoot.dataset.hookurl);
    }

  },
  beforeMount () {
    // Get the ID tag containing the drupal instance id.
    this.instanceId = this.$parent.$el.id;
    let lang = document.getElementsByTagName('html')[0].getAttribute('lang')
    this.$store.commit('SET_LANG', lang);
    let userRoles = document.getElementsByTagName('body')[0].getAttribute('class').match(/user-has-role-[^\s]+/g);
    this.$store.commit('SET_USER_ROLES', userRoles.map(function(x){return x.replace('user-has-role-','');}));
  },
  watch: {
    $route (to, from) {
      // react on current step url changes to handel browser history
      if (Object.prototype.hasOwnProperty.call(to.query, "Step") && to.query.Step.length ) {
        if (from.query.Step !== to.query.Step) {
          this.$store.commit('SET_WGK_CURRENT_STEP', to.query.Step);
        }
      }
    },
    isMobile: function() {
      this.$store.dispatch('updateDesktopOptimizedSwitch', this.isMobile);
    },
    desktopOptimizedSwitch: function() {
      // better force schema update if switching between mobile and desktop on desktop optimized version
      this.$store.dispatch('forceSchemaUpdate', this.$store.state.wgkCurrentStep);
    }

  }
};
</script>

<style lang="scss">

@font-face {
  font-family: AvenirNext-DemiBold;
  src: url(./fonts/6afe4676-059a-4aa8-b891-29856bbcba22.woff2) format("woff2"),
  url(./fonts/a9817c16-2a79-49bf-8543-6c846d73a52f.woff) format("woff");
}
@font-face {
  font-family: AvenirNext-Medium;
  src: url(./fonts/f5d4f93b-454a-43e0-9ae8-7f1271b5c0fd.woff2) format("woff2"),
  url(./fonts/72556e8c-c677-48d8-81ff-3eb8fc50033b.woff) format("woff");
}

@import '../src/sass/variables.scss';
h1 {
  color: $c-dehn-gray--darkest;
}

.wgk-wrapper {
  b, strong {
    font-family: AvenirNext-DemiBold, sans-serif;
    font-weight: normal;
  }
}


.theme--light.v-application {
  background: $c-dehn-gray--lighter !important;
}

.wgk-dehn-bgcolor__light {
  background: $c-dehn-gray--lightest;
}

.dehn-bgcolor__light {
  background: $c-dehn-gray--lighter;
}

.dehn-bgcolor__white {
  background: $c-dehn-white;
}

.dehn-bgcolor__dark {
  background: $c-dehn-gray--darkest;
}

.dehn-bgcolor__red {
  background: $c-dehn-red;
}

.wgk-container__outer {
  padding: 0 $container-padding-x-small;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .wgk-container__outer {
    padding: 0 $container-padding-x-medium 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .wgk-container__outer {
    padding: 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .wgk-container__outer {
    padding: 48px $container-padding-x-large;
  }
}

.theme--light.v-stepper {
  background: $c-dehn-gray--lightest !important;
}

.theme--light.v-divider {
  border-color: $c-dehn-gray;
}

.dehn-v-stepper .v-stepper__content { transition: none; }

.v-stepper--alt-labels .v-stepper__label {
  text-align: center;
}

.dehn-v-stepper .v-stepper__step:first-child {
  //padding-left: 0;
}

.dehn-v-stepper .v-stepper__step:last-child {
  //padding-right: 0;
}

.dehn-vform {
  h3 {
    color: $c-dehn-text;
  }
}

.dehn-vform .v-label {
  font-size: 14px;
  font-family: AvenirNext-DemiBold, sans-serif;
}

.v-card--disabled > :not(.v-card__progress) {
  opacity: 0.3;
}

.wgk-card {
  padding: 0 0;
}

.wgk-card-transparent {
  background: none !important;
  .v-alert {
    margin-top: 16px;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .wgk-card  {
    box-shadow: 10px 0 0 0 rgb(255, 255, 255), -10px 0 0 0 rgb(255, 255, 255)  !important;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .wgk-card {
    padding: 10px;
  }
}

</style>
